const cbd = {
  stateRestriction: "This product cannot ship to the following states: {{states}}",
} as const;

export { cbd };
